exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadStatus .el-progress-circle {\n  background: rgba(0,0,0,0.4);\n}\n.uploadStatus .el-progress-circle .el-progress-circle__track {\n  stroke: rgba(255,255,255,0.4);\n}\n.uploadStatus .el-progress__text {\n  font-size: 14px;\n  color: #fff;\n}\n", ""]);

// exports
